
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes02On as ObiDiodes02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-02-on.js';
 
 
 

 
 export const ObiDiodes02On = createComponent({
   react: React,
   tagName: 'obi-diodes-02-on',
   elementClass: ObiDiodes02OnElement,
   events: {
     
   }
  });
 
 